import { message } from 'antd';
import messageWarn from '@/assets/images/login/messageWarn.png';
import messageLoading from '@/assets/images/login/messageLoading.png';
import messageSuccess from '@/assets/images/login/messageSuccess.png';
import './index.less';

let lmessage = {
  error: (text: string | undefined) => {
    return message.error({
      className: 'loginMessage',
      content: text,
      icon: <img src={messageWarn} alt="" />
    });
  },
  success: (text: string) => {
    return message.error({
      className: 'loginMessage',
      content: text,
      icon: <img src={messageSuccess} alt="" />
    });
  },
  loading: (text: string, duration?: number) => {
    return message.info({
      className: 'loginMessage',
      content: text,
      duration: duration,
      icon: <img className="rotate" src={messageLoading} alt="" />
    });
  }
};

export { lmessage };
